import { render, staticRenderFns } from "./DepartmentListContainer.vue?vue&type=template&id=09efbed8"
import script from "./DepartmentListContainer.ts?vue&type=script&lang=ts&external"
export * from "./DepartmentListContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports